import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { CacheService } from './cache.service';
import { AuthService } from './auth.service';


interface TypeStatusActionPlan {
    txtTypeStatusActionPlan: string;
    isDisabled?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class ActionPlanService {

    className = 'ActionPlanService';

    constructor(
        private http: HttpClient,
        @Inject("environment") private environment: any,
        private authService: AuthService,
        private cacheService: CacheService
    ) { }

    getAllAudited() {
        return this.http.get(this.environment.base_URL + "/recommendation", { params: { user: this.authService.getUserId() } })
            .pipe(map((recommendations: any) => {
                const filtered = _.filter(recommendations, recommendation => _.get(recommendation, 'actionPlan.status?.txtTypeStatusActionPlan') !== 'PENDIENTE');
                return _.map(filtered, item => {
                    const actionPlan = item.actionPlan;
                    delete item['actionPlan'];
                    actionPlan.report = item.report;
                    delete item['report'];
                    actionPlan.fact = item.factObserverObj;
                    delete item['factObserverObj'];
                    actionPlan.recommendation = item;
                    return actionPlan;
                });
            }));
    }

    getFilteredActionPlans(params) {
        return this.http.get<any[]>(this.environment.base_URL + "/filtered-recommendations", { params })
            .pipe(map((recommendations: any) => {
                const filtered = _.filter(recommendations.content, recommendation => _.get(recommendation, 'actionPlan.status?.txtTypeStatusActionPlan') !== 'PENDIENTE');
                recommendations.content = _.map(filtered, item => {
                    const actionPlan = item.actionPlan;
                    delete item['actionPlan'];
                    actionPlan.report = item.report;
                    delete item['report'];
                    actionPlan.fact = item.factObserverObj;
                    delete item['factObserverObj'];
                    actionPlan.recommendation = item;
                    return actionPlan;
                });

                return recommendations;
            }));
    }

    getActionPlanByRecommendationId(id) {
        return this.http.get<any[]>(this.environment.base_URL + `/recommendation/${id}`)
            .pipe(map((recommendation: any) => {
                const actionPlan = recommendation.actionPlan;
                delete recommendation['actionPlan'];
                actionPlan.recommendation = recommendation;
                return actionPlan;
            }));
    }

    getTypeStatusActionPlan(cache = true, cacheKey = "typeStatusActionPlan") {
        if (this.cacheService.canUseCache(cacheKey) && cache) {
            return this.cacheService.getCacheData(cacheKey);
        } else {
            const observable = this.http.get(this.environment.base_URL + "/types-status-action-plan").pipe(map((res) => {
                this.cacheService.updateCacheData(res, cacheKey);
                return res;
            }));
            this.cacheService.updateCacheReq(cacheKey);
            return observable;
        }
    }

    getTypeStatusActionPlanFilters(cache = true, cacheKey = "typeStatusActionPlanFilters") {
        if (this.cacheService.canUseCache(cacheKey) && cache) {
            return this.cacheService.getCacheData(cacheKey);
        } else {
            const observable = this.http.get<TypeStatusActionPlan[]>(this.environment.base_URL + "/types-status-action-plan").pipe(map((res: TypeStatusActionPlan[]) => {
                _.forEach(res, (type: TypeStatusActionPlan) => {
                    if (type.txtTypeStatusActionPlan === 'PENDIENTE') {
                        type.isDisabled = true;
                    }
                });
                this.cacheService.updateCacheData(res, cacheKey);
                return res;
            }));
            this.cacheService.updateCacheReq(cacheKey);
            return observable;
        }
    }

    send(actionPlanDetail) {
        return this.http.post(this.environment.base_URL + "/recommendation/action-plan/send", actionPlanDetail);
    }
}